import {
	birdSound,
	coinSound,
	jumpSound,
} from '../audio';

let soundPlayer;
const soundMap = {};

function runEmitters(emitters) {
	soundPlayer = emitters.map(emitter => emitter());
}

function redux(store) {
	return next => action => {
		soundPlayer.forEach(emitter => {
			emitter(store, action);
		});

		next(action);
	};
}

export const soundMiddleware = {
	redux,
	runEmitters,
};

function initSounds() {
	soundMap[coinSound] = new Audio(coinSound);
	soundMap[birdSound] = new Audio(birdSound);
	soundMap[jumpSound] = new Audio(jumpSound);
}

initSounds();

export function playSound(sound) {
	if (!soundMap[sound]) {
		return;
	}

	soundMap[sound].play();
}

export const SoundTypeEnums = {
	LOOP: 'loop',
	SINGLE: 'single',
};

export function generalRing() {
	playSound(coinSound);
}
